import { Component } from '@angular/core';
import { FashionLoginComponent } from 'gung-standard';

@Component({
  selector: 'car-liner-login',
  templateUrl: './car-liner-login.component.html',
  styleUrls: ['./car-liner-login.component.scss'],
  standalone: false
})
export class CarLinerLoginComponent extends FashionLoginComponent {
  onSubmit() {
    super.onSubmit();
    localStorage.removeItem('selectedCustomerId');
  }
}
